export default "__VITE_ASSET__36da219d__"